<template>
  <section>
    <Title :title-name="'COVID-19 PORTAL'" :title-link="title.GeneralInfomation.titleLink" />
    <div class="container" style="margin-top: 14pt">
      <p style="white-space: pre-line">
        {{ pax.covid19_portal[key]['CONTENT_' + pax.arr] || pax.covid19_portal[key].CONTENT }}
      </p>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title'
export default {
  name: 'GeneralInfomation',
  components: {
    Title
  },
  data() {
    return {
      key: 0
    }
  },
  beforeCreate() {
    this.$emit('changeLinkName', '')
  },
  created() {
    this.key = this.$route.query.key
  }
}
</script>
